/**
 * Manipulate dates by adding / removing relative timeframe
 * @param {'add' | 'subtract'} method value for manipulation, default is 'add'
 * @param {Date | number | string} date value in string, number or date object
 * @param {'day' | 'month' | 'year'} unit string that represents unit
 * @param {number} value number that represents number of units
 * @returns {string} manipulated date
 */
import dayjs from 'dayjs';

export const manipulateDate = ({
  method = 'add',
  date,
  unit,
  value,
}: {
  method?: 'add' | 'subtract';
  date: string | number | Date;
  unit: 'day' | 'month' | 'year';
  value: number;
}): string => {
  if (method === 'add') return dayjs(date).add(value, unit).toString();
  return dayjs(date).subtract(value, unit).toString();
};
